import {Condition} from "./condition";

export class Criterion {
  type: string; // all, any, none
  conditions: Condition[];

  constructor(type: string) {
    this.type = type;
    this.conditions = [
      new Condition()
    ]
  }
}
